import type { UserType } from '~/model/UserType';
import { UserTypeEnum } from '~/model/UserType';

export const isGuestUser = (user: UserType) =>
  user?.['@id'] && user?.['@type'] === UserTypeEnum.GUEST_USER;

export const isMainUser = (user: UserType) =>
  user?.['@id'] && user?.['@type'] === UserTypeEnum.USER;

export const isAuthenticatedAsMainUser = (
  user: UserType,
  authenticated: boolean,
) => !!authenticated && isMainUser(user);
